module.exports = __webpack_public_path__ + "img/page5Img3.2a454ebd.png";